import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const ModelDesc = (props) => {
  return (
    <FormGroup controlId="modelDesc">
      <Col componentClass={ControlLabel} sm={5}>
        Model Description
      </Col>
    <Col sm={7}>
        <FormControl
          type="text"
          value={props.modelDesc}
          onChange={props.handleChangeModelDesc}
          autoComplete="off"
          />
    </Col>
    </FormGroup>
  )
}

ModelDesc.propTypes = {
  modelDesc: PropTypes.string,
  handleChangeModelDesc: PropTypes.func,

};

export default ModelDesc;



// WEBPACK FOOTER //
// ./src/app/components/coverNotePVComponent/modelDesc/ModelDesc.js